import { render, staticRenderFns } from "./RegistrationRegionSelect.vue?vue&type=template&id=e20ed8c8&scoped=true"
import script from "./RegistrationRegionSelect.vue?vue&type=script&lang=js"
export * from "./RegistrationRegionSelect.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRegionSelect.vue?vue&type=style&index=0&id=e20ed8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ed8c8",
  null
  
)

export default component.exports